import * as React from "react";
import { useEffect, useState } from "react";
import { ContextStore } from "../../../../../../../../react-core/Flux/Variables";
import { MoneyDisplayHelper } from "../../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { ContextType } from "../../../../../../../../Wrap/Constants/Enums/ContextType";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { WithdrawalStatus } from "../../../../../../../../Wrap/Constants/Enums/Domain/WithdrawalStatus";
import { UserClaim } from "../../../../../../../../Wrap/Constants/Enums/UserClaim";
import { ClientAccount } from "../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { RegularWithdrawalModel } from "../../../../../../../../Wrap/Models/Models/Payments/Withdrawals/RegularWithdrawalModel";
import { WithdrawalOverviewModel } from "../../../../../../../../Wrap/Models/Models/Payments/Withdrawals/WithdrawalOverviewModel";
import { Permission } from "../../../../../../../Shared/Permission/Permission";
import { Table } from "../../../../../../../Shared/Table/Table";
import { Navigator } from "../../../../../../../Shared/Wizards/Entities/Navigator";
import { Methods } from "../../../../../../Common/CommonHelper";
import { Urls } from "../../../../../../Urls";
import { BondRegularPaymentAction } from "../../Transactions/Actions/BondRegularPaymentAction";
import { SubAccountTypeHelper } from "../../../../Common/Helpers/SubAccountTypeHelper";
import { TransactionEnum } from "../../Transactions/Resource/Contents";
import { ProductOverviewWithdrawalAction } from "../Action/ProductOverviewWithdrawalAction";

interface IProductOverviewWithdrawalProps {
    subAccountHierarchyId: string;
    subClAccountId: string;
    selectedProduct: SubAccountType;
    headaccount: ClientAccount;
}

export const ProductOverviewWithdrawal = (props: IProductOverviewWithdrawalProps) => {
    const [data, setData] = useState<WithdrawalOverviewModel>(null);
    const [bondData, setBondData] = useState(null);

    useEffect(() => {
        ProductOverviewWithdrawalAction.getWithdrawalDetails(props.subAccountHierarchyId, (data) => {
            setData(data);
        });
        if (SubAccountTypeHelper.isBond(props.selectedProduct)) {
            BondRegularPaymentAction.getBondRegularPayment(props.subAccountHierarchyId, (data) => {
                setBondData(data.find((x: any) => x.ClAccountId == props.subClAccountId));
            });
        }
    }, []);

    return (
        <>
            <div className="ad d1">
                <h1 className="sr-only">Withdrawals</h1>
                <h2 className="mb-22">Active instructions</h2>

                {(props.selectedProduct == SubAccountType.OnshoreBond ||
                    props.selectedProduct == SubAccountType.OffshoreBond) && (
                    <p>If you need to make any changes to these payments please email wrap_money_out@abrdn.com</p>
                )}

                <div className="row wide-gutter">
                    <div className="col-12 col-sm-fluid col-equalise">
                        <div className="d-flex f-direction-column">
                            <div className="row mb-0">
                                <div className="col-fluid col-middle">
                                    <h3 className="mb-0">Current regular withdrawal instructions</h3>
                                </div>

                                {data?.RegularWithdrawals?.length > 0 && (
                                    <Permission userClaim={UserClaim.AdviserPortalPaymentsAndWithdrawlsCanView}>
                                        <div className="col-auto col-middle">
                                            <button
                                                type="button"
                                                className="edit-circle-icon-button label-sr-only"
                                                title="Edit"
                                                onClick={() =>
                                                    Navigator.navigateTo(
                                                        Urls.get().main.PortfolioDashboard({
                                                            hierarchyId: ContextStore.getUrlParamsHierarchyId(
                                                                ContextType.Customer
                                                            ),
                                                        }).transactions,
                                                        {
                                                            scrollAfterNavigating: true,
                                                            queryParamsObject: {
                                                                transtypeselect: TransactionEnum.paymentsWithdrawals,
                                                                hierarchyid: props.subAccountHierarchyId,
                                                            },
                                                        }
                                                    )
                                                }
                                            >
                                                <span className="icon"></span>
                                                <span className="text sr-only">Edit</span>
                                            </button>
                                        </div>
                                    </Permission>
                                )}
                            </div>
                            {data?.RegularWithdrawals?.length > 0 && (
                                <div className="panel-subtle pt-10 pb-10 f-grow-1">
                                    <Table
                                        cssWrapper="table-subtle table-first-last-cell-padding-reset"
                                        data={data.RegularWithdrawals}
                                        col={[
                                            {
                                                title: "Amount",
                                                key: "Amount",
                                                render: (data: number | undefined, row: RegularWithdrawalModel) => {
                                                    if (row.Amount == null) {
                                                        return `${row.Percentage.toFixed(2)}%`;
                                                    }

                                                    return MoneyDisplayHelper.FromatMoneyDisplay(
                                                        data,
                                                        CurrencyCode.GBP,
                                                        true,
                                                        2
                                                    );
                                                },
                                            },
                                            {
                                                title: "Frequency",
                                                key: "Frequency",
                                                render: (data, row) => {
                                                    return Methods.getFormatFrequencyType(data);
                                                },
                                            },
                                            {
                                                title: "Payer",
                                                key: "PayeeReference",
                                                render: (data, row) => {
                                                    return Methods.getPayeeReference(data);
                                                },
                                            },

                                            {
                                                title: "Next withdrawal",
                                                key: "NextPaymentDate",
                                                render: (data, row, index) => {
                                                    return JsonDateParser.getFormatDate(data, "dd/MM/yyyy");
                                                },
                                            },
                                        ]}
                                    />
                                </div>
                            )}
                            {!(
                                data?.RegularWithdrawals?.length > 0 ||
                                ((props.selectedProduct == SubAccountType.OnshoreBond ||
                                    props.selectedProduct == SubAccountType.OffshoreBond) &&
                                    bondData?.Payments?.filter(
                                        (x) =>
                                            (x.CurrentStatus == WithdrawalStatus.Active &&
                                                !JsonDateParser.isToday(x.FinalDate)) ||
                                            x.CurrentStatus == WithdrawalStatus.FutureDated
                                    ).length > 0)
                            ) && (
                                <div className="panel-subtle f-grow-1">
                                    <span>No regular withdrawal(s) currently set up for this client</span>
                                </div>
                            )}
                            {(props.selectedProduct == SubAccountType.OnshoreBond ||
                                props.selectedProduct == SubAccountType.OffshoreBond) &&
                                bondData?.Payments?.filter(
                                    (x) =>
                                        (x.CurrentStatus == WithdrawalStatus.Active &&
                                            !JsonDateParser.isToday(x.FinalDate)) ||
                                        x.CurrentStatus == WithdrawalStatus.FutureDated
                                ).length > 0 && (
                                    <div className="panel-subtle pt-10 pb-10 f-grow-1">
                                        <Table
                                            cssWrapper="table-subtle table-first-last-cell-padding-reset"
                                            data={bondData?.Payments?.filter(
                                                (x) =>
                                                    (x.CurrentStatus == WithdrawalStatus.Active &&
                                                        !JsonDateParser.isToday(x.FinalDate)) ||
                                                    x.CurrentStatus == WithdrawalStatus.FutureDated
                                            )}
                                            col={[
                                                {
                                                    title: "Amount",
                                                    key: "Amount",
                                                    render: (data, row) =>
                                                        MoneyDisplayHelper.FromatMoneyDisplay(
                                                            data,
                                                            CurrencyCode.GBP,
                                                            true,
                                                            2
                                                        ),
                                                },
                                                {
                                                    title: "Frequency",
                                                    key: "Frequency",
                                                    render: (data, row) => {
                                                        return Methods.getFormatFrequencyType(data);
                                                    },
                                                },
                                                {
                                                    title: "Payer",
                                                    key: "CombinedBankDetails",
                                                    render: (data, row) => {
                                                        return row.AccountName + " | " + data;
                                                    },
                                                },
                                                {
                                                    title: "Next withdrawal",
                                                    key: "NextDate",
                                                },
                                            ]}
                                        />
                                    </div>
                                )}
                        </div>
                    </div>
                    <div className="col-12 col-sm-fluid col-equalise">
                        <div className="d-flex f-direction-column">
                            <h3 className="mb-4">Expected single withdrawal</h3>

                            {data?.SingleWithdrawals?.length > 0 ? (
                                <div className="panel-subtle pt-10 pb-10 f-grow-1">
                                    <Table
                                        cssWrapper="table-subtle table-first-last-cell-padding-reset"
                                        data={data?.SingleWithdrawals}
                                        col={[
                                            {
                                                title: "Amount",
                                                key: "Amount",
                                                render: (data, row) =>
                                                    MoneyDisplayHelper.FromatMoneyDisplay(
                                                        data,
                                                        CurrencyCode.GBP,
                                                        true,
                                                        2
                                                    ),
                                            },
                                            {
                                                title: "Payer",
                                                key: "PayeeReference",
                                                render: (data, row) => {
                                                    return Methods.getPayeeReference(data);
                                                },
                                            },
                                        ]}
                                    />
                                </div>
                            ) : (
                                <div className="panel-subtle f-grow-1">
                                    <span> No single withdrawal(s) currently set up for this client</span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <hr />
                <h2>Completed instructions</h2>

                {data?.CompletedWithdrawalOverview?.CompletedWithdrawalsByPayee?.length > 0 ? (
                    <div className="row wide-gutter">
                        <div className="col-12 col-sm-6">
                            <div className="panel-subtle pt-10 pb-10 mb-40">
                                <Table
                                    cssWrapper="table-subtle table-first-last-cell-padding-reset"
                                    data={data?.CompletedWithdrawalOverview?.CompletedWithdrawalsByPayee}
                                    col={[
                                        {
                                            title: " ",
                                            key: "PayeeReference",
                                            render: (data, row) => {
                                                return Methods.getPayeeReference(data);
                                            },
                                        },
                                        {
                                            title: "Regular withdrawal",
                                            key: "RegularWithdrawal",
                                            thCssWrapper: "cell-right",
                                            tdCssWrapper: "cell-right",
                                            render: (data, row) =>
                                                MoneyDisplayHelper.FromatMoneyDisplay(data, CurrencyCode.GBP, true, 2),
                                        },
                                        {
                                            title: "Single withdrawal",
                                            key: "SingleWithdrawal",
                                            thCssWrapper: "cell-right",
                                            tdCssWrapper: "cell-right",
                                            render: (data, row) =>
                                                MoneyDisplayHelper.FromatMoneyDisplay(data, CurrencyCode.GBP, true, 2),
                                        },
                                    ]}
                                    TotalBody={[
                                        { data: "Total", colSpan: 1 },
                                        {
                                            data: MoneyDisplayHelper.FromatMoneyDisplay(
                                                data?.CompletedWithdrawalOverview?.RegularWithdrawalTotal,
                                                CurrencyCode.GBP,
                                                true,
                                                2
                                            ),
                                            tfTdCssWrapper: "cell-right",
                                        },
                                        {
                                            data: MoneyDisplayHelper.FromatMoneyDisplay(
                                                data?.CompletedWithdrawalOverview?.SingleWithdrawalTotal,
                                                CurrencyCode.GBP,
                                                true,
                                                2
                                            ),

                                            tfTdCssWrapper: "cell-right",
                                        },
                                    ]}
                                />
                            </div>
                        </div>
                    </div>
                ) : null}

                <Permission userClaim={UserClaim.AdviserPortalPaymentsAndWithdrawlsCanView}>
                    <p>
                        To view all withdrawals{" "}
                        <a
                            href="javascript:void(0);"
                            className="hyperlink"
                            onClick={() =>
                                Navigator.navigateTo(
                                    Urls.get().main.PortfolioDashboard({
                                        hierarchyId: ContextStore.getUrlParamsHierarchyId(ContextType.Customer),
                                    }).transactions,
                                    {
                                        scrollAfterNavigating: true,
                                        queryParamsObject: {
                                            transtypeselect: TransactionEnum.paymentsWithdrawals,
                                            hierarchyid: props.subAccountHierarchyId,
                                        },
                                    }
                                )
                            }
                        >
                            click here
                        </a>
                        .
                    </p>
                </Permission>
            </div>
        </>
    );
};
